import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthRequest } from '../../shared/types/auth-request';
import {Teacher} from "../../shared/types/teacher";

interface AuthState {
  authenticated: boolean;
  authChecked: boolean;
  loading: boolean;
  error: string | null;
  currentTeacher: Teacher | null;
}

const initialState: AuthState = {
  authenticated: false,
  authChecked: false,
  loading: false,
  error: null,
  currentTeacher: null,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    checkAuthRequest(state) {
      state.loading = true;
      state.authChecked = false;
    },
    checkAuthSuccess(state, action: PayloadAction<Teacher>) {
      state.authenticated = true;
      state.loading = false;
      state.authChecked = true;
      state.currentTeacher = action.payload;
    },
    checkAuthFailure(state) {
      state.authenticated = false;
      state.loading = false;
      state.authChecked = true;
    },
    loginRequest(state, action: PayloadAction<AuthRequest>) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<Teacher>) {
      state.authenticated = true;
      state.loading = false;
      state.currentTeacher = action.payload;
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.authenticated = false;
      state.loading = false;
      state.error = action.payload;
    },
    logoutRequest(state) {
      state.loading = true;
    },
    logoutSuccess(state) {
      state.authenticated = false;
      state.loading = false;
      state.currentTeacher = null;
    }
  },
});

export const {
  checkAuthRequest,
  checkAuthSuccess,
  checkAuthFailure,
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutRequest,
  logoutSuccess,
} = authSlice.actions;
